import { Validator } from '../validators/validator';
import { Config } from '../config';
import { View } from '../view/view';
import { currencySymbols } from '../config/currency-symbols';
import { FormTypes } from './form-types';
import { PaymentData } from '../config/payment-data';
import { Logger } from '../logger';
import { Order } from '../config/order';
import { ResourceCache } from '../utils/resource-cache';
import { Subject } from 'rxjs';

export class Form {

    protected validationContext: any;
    protected validators: Validator[] = [];
    protected config: Config = {};
    protected view: View = new View();
    protected callbacks: any = {};
    public parentSubject: Subject<any> | undefined;
    public type: FormTypes = {} as FormTypes;
    public paymentData: PaymentData = {
        singlePaymentAmount: 0,
        subscriptionAmount: 0,
        amount: 0,
        message: '',
        selectedProducts: [],
        type: '',
        quantity: 0
    };
    logger: Logger = {} as Logger;
    private activeInternal = true;
    isNoPayment = false;
    cacheService = ResourceCache.getInstance();
    quantity?: number;
    step?: number | null;

    constructor() {
    }

    set active(isActive: boolean) {
        this.activeInternal = isActive;
        this.view.setVisible(isActive);
    }

    get active() {
        return this.activeInternal;
    }

    validate() {
        let valid = true;
        const promises = this.validators.map(x => x.validate(this.validationContext));

        return Promise.all(promises).then(results => results.every(x => valid = valid && x));
    }

    submit(order: Order): Promise<any> {
        return Promise.resolve();
    }

    render(): Promise<any> {
        return Promise.resolve();
    }

    triggerEvent(eventName: string, data?: any) {
        const callback = this.callbacks[eventName];

        if (callback) {
            return callback(data);
        }
    }

    toTwoDec(num: number) {
        return Math.round(num * 100) / 100;
    }

    init(config: Config, callback: any = {}, ...args: any): Promise<any> {
        this.callbacks = callback;
        this.logger = new Logger(config);
        this.config = config;
        return Promise.resolve();
    }

    postSubmit(submissionContext: Config): Promise<any> {
        return Promise.resolve();
    }

    upSellSubmit(upSellResponse: any): Promise<any> {
        return Promise.resolve();
    }

    protected loadScript(scriptSrc: string): Promise<any> {
        if (this.cacheService.checkIfJsLoaded(scriptSrc)) {
            return Promise.resolve();
        }

        return new Promise((resolve: any, reject: any) => {
            this.cacheService.addJsToCache(scriptSrc);
            const script = document.createElement('script');
            script.type = 'text/javascript';
            if (scriptSrc != null) {
                script.src = scriptSrc;
            }
            document.body.appendChild(script);
            script.onload = () => resolve();
        });
    }

    protected getCookie(name: string) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
    }

    protected formatMoney(amount: string, currency: any): string {
        let finalAmount: any = +amount || 0;
        finalAmount = finalAmount.toFixed(2);
        const minimumFractionDigits = 2;
        finalAmount = parseFloat(finalAmount);
        const symbol: string = currencySymbols[currency];
        return `${symbol}${finalAmount.toLocaleString(undefined, { minimumFractionDigits: minimumFractionDigits })}`;
    }

    hidePaymentFields() { }

    showPaymentFields() { }

    setAmountFromUrl(urlAmount: string) { }

    getSelectedProducts(): any { }

    showForm() { }

    hideForm() { }

}
